module.exports = __webpack_public_path__ + "img/org-coral-gas.28cbed42.jpg";